<template>
  <v-container class="form-container-mobile">
    <div class="form-content">
      <div class="text-center slide-in-up">
        <h1 class="welcome-title">ברוכים הבאים!</h1>
        <p class="welcome-subtitle">אנא הכניסו את שם המשתמש והסיסמה שלכם</p>
        <p class="welcome-subtitle">לצורך התחברות למערכת</p>
      </div>
      
      <v-form @submit.prevent="submitHandler" ref="form2">
        <div class="input-wrapper slide-in-up" style="animation-delay: 0.1s;">
          <v-text-field 
            class="custom-text-field" 
            hide-details 
            v-model="username" 
            label="שם משתמש" 
            solo
            text
          ></v-text-field>
        </div>
        
        <div class="input-wrapper slide-in-up" style="animation-delay: 0.2s;">
          <v-text-field 
            class="custom-text-field" 
            type="password" 
            hide-details 
            v-model="password" 
            label="סיסמה" 
            solo
            text
          ></v-text-field>
        </div>
      </v-form>
      
      <div class="button-wrapper slide-in-up" style="animation-delay: 0.3s;">
        <v-btn 
          @click="sendAuth" 
          class="gradiant-bt custom-button" 
          dark
          elevation="4"
          text
        >
          <span class="button-text">המשך</span>
        </v-btn>
      </div>
      
      <div class="alternative-login slide-in-up" style="animation-delay: 0.4s;" @click="$router.replace('/login-phone')">
        <span class="alternative-text">או הכנסו באמצעות אימות טלפוני</span>
      </div>
    </div>

    <v-row v-if="progressShow" class="progress-row">
      <v-col class="d-flex justify-center">
        <v-progress-circular indeterminate color="white" size="50"></v-progress-circular>
      </v-col>
    </v-row>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>

  </v-container>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {

  components: {
    SnackBar
  },

  data: () => ({
    isResponsive: false,
    account_id: "",
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    username: "",
    password: "",
  }),
  methods: {
    async loginByUserName() {

      this.progressShow = true
      let MyJSON = JSON.stringify({ username: this.username, password: this.password });
      let api = process.env.VUE_APP_BASE_URL + "/auth/login2"

      try {
        const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, ""));
        this.progressShow = false;
        const jsonObject = await response.json();
        if (response.status >= 400) {
          this.showSnackBar("שגיאת התחברות: " + jsonObject.message, "red");
        } else if (response.status === 200) {
          this.showSnackBar("התחברת בהצלחה!", "green");
          localStorage.setItem('token', jsonObject.token);
          const role = jsonObject.role;
          if (role === "user") {
            this.$router.replace({ name: "callHistory" })
          } else if (role === "admin") {
            this.$router.replace({ name: role })
          }
        }
      } catch (error) {
        this.showSnackBar("Error Login: " + error, "red");
      }

    },
    sendAuth() {
      this.loginByUserName();
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
    beforeDestroy() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }
  },
  watch: {
    $route() {
      document.title = 'Login | CLICK-CALL'
    },
  },
  mounted() {
    if (this.startListeningToOtp) {
      this.startListeningToOtp();
    }
  },
  created() {
    this.abortController = new AbortController();
  }

}
</script>
<style scoped>
/* Mobile-optimized glassmorphism container */
.form-container-mobile {
  position: absolute;
  bottom: 5%;
  width: 100%;
  padding: 30px 20px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 30px 30px 0 0;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.1);
}

.form-content {
  width: 100%;
}

/* Mobile typography with text shadows */
.welcome-title {
  color: white;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 12px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.welcome-subtitle {
  color: white;
  font-size: 15px;
  margin: 2px 0;
  opacity: 0.95;
  line-height: 1.4;
}

/* Mobile input styling with enhanced interactions */
.input-wrapper {
  margin-top: 15px;
  width: 100%;
}

.custom-text-field >>> .v-input__control .v-input__slot {
  background-color: white;
  border-radius: 20px;
  border: 2px solid #0052cc;
  padding: 8px 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 82, 204, 0.15);
}

.custom-text-field >>> .v-input__control .v-input__slot:focus-within {
  border-color: #0066ff;
  box-shadow: 0 0 0 4px rgba(0, 82, 204, 0.2);
  transform: scale(1.02);
}

/* Mobile button with ripple effect */
.button-wrapper {
  margin-top: 20px;
  width: 100%;
}

.custom-button {
  width: 100%;
  border-radius: 20px;
  padding: 20px 16px !important;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.custom-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.custom-button:active::before {
  width: 300px;
  height: 300px;
}

.custom-button:active {
  transform: scale(0.98);
}

.button-text {
  font-weight: bold;
  font-size: 18px;
  position: relative;
  z-index: 1;
}

.gradiant-bt {
  background: linear-gradient(94deg, rgba(140, 159, 245, 1) 1%, rgba(9, 104, 224, 1) 70%);
}

/* Alternative login with touch-friendly styling */
.alternative-login {
  margin-top: 30px;
  cursor: pointer;
  text-align: center;
  padding: 10px;
  transition: transform 0.2s ease;
}

.alternative-login:active {
  transform: scale(0.98);
}

.alternative-text {
  color: white;
  font-size: 15px;
  text-decoration: underline;
  opacity: 0.9;
}

.progress-row {
  margin-top: 15px;
}

/* Slide-in animation for mobile */
.slide-in-up {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile responsive adjustments */
@media (max-width: 600px) {
  .form-container-mobile {
    padding: 25px 15px;
  }
  
  .welcome-title {
    font-size: 26px;
  }
  
  .welcome-subtitle {
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  .form-container-mobile {
    padding: 20px 12px;
  }
  
  .welcome-title {
    font-size: 24px;
  }
  
  .welcome-subtitle {
    font-size: 13px;
  }
  
  .button-text {
    font-size: 16px;
  }
}

@media (max-height: 700px) {
  .form-container-mobile {
    bottom: 2%;
  }
  
  .input-wrapper {
    margin-top: 12px;
  }
  
  .button-wrapper {
    margin-top: 15px;
  }
  
  .alternative-login {
    margin-top: 20px;
  }
}
</style>
